import React from 'react'

import Header from './components/Header'
import Input from './components/Input'

const App = () => {
  return (
    <>
      <Header />
      <Input />
    </>
  )
}

export default App